export default __webpack_public_path__ + "static/media/WildHills.664c55dc.jpg";